import { createContext } from "react";
import { settings } from "../config";

export const AppContext = createContext(settings);
export const AuthContext = createContext({ currentModerator: null });
export const PuppetContext = createContext({ selectedPuppet: null, availablePuppets: [] });
